import LessonRouteClient from "@/components/student/LessonRouteClient";
import { useParams } from "react-router-dom";

export default function StudentLessonRoutePage() {
    const { id, lessonId } = useParams<{ id: string; lessonId: string }>();
    return <LessonRouteClient courseId={id || ""} lessonId={lessonId || ""} />;
}
